import { render, staticRenderFns } from "./CardBroken.vue?vue&type=template&id=1560ed20&"
import script from "./CardBroken.vue?vue&type=script&lang=js&"
export * from "./CardBroken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports